export default {
  createPlan: 'Crear Plan',
  noModelsAvailable: 'No hay modelos disponibles. Crea el primero o habla con el administrador.',
  search: 'Buscar',
  loading: 'Cargando...',
  noPlansAvailable: 'No hay planes disponibles para este modelo',
  running: 'Ejecutando...',
  headerName: 'Nombre',
  headerBudget: 'Presupuesto',
  headerPredictedKpi: '{kpiName} Proyectadas',
  headerPeriod: 'Período',
  headerCreated: 'Creado',
  defaultKpiName: 'Ventas',
  defaultCurrency: 'USD',
  sharedWithExternalUsers: 'Compartido con usuarios externos',
  createFromScratch: 'Desde Cero',
  createLastYearActualBudget: 'Año Anterior, Presupuesto Real (Strategy Check)',
  createLastYearActualBudgetWeekly: 'Año Anterior, Presupuesto Real (Strategy Check)',
  createLastYearNoBudget: 'Año Anterior, Sin Presupuesto',
  createNextYearBudgetPropagationMonthly: 'Año Siguiente, Propagación de Presupuesto Real (Forward Looking)',
  createNextYearBudgetPropagationWeekly: 'Año Siguiente, Propagación de Presupuesto Real (Forward Looking)',
  createLastYearOnePulseMonthly: 'Año Anterior, Un Pulso de inversión en medios',
  createLastYearOnePulseWeekly: 'Año Anterior, Un Pulso de inversión en medios',
  chooseFromScratchDescription: 'Define tú el período e ingresa la inversión de cada canal.',
  chooseActualBudgetTitle: 'Presupuesto Real del Año Anterior',
  chooseActualBudgetDescription: 'Carga la inversión real por canal de los últimos 12 meses de datos.',
  chooseNoBudgetTitle: 'Año Anterior, Sin Presupuesto',
  chooseNoBudgetDescription: 'El mismo período de los últimos 12 meses con todos los canales en cero, listo para completar.',
  chooseOnePulseTitle: 'Año Anterior, Un Pulso',
  chooseOnePulseDescription: 'Un único pulso al nivel de saturación de cada canal en el primer período y luego cero, para ver su carry-over.',
  chooseNextYearTitle: 'Propagación de Presupuesto del Año Siguiente',
  chooseNextYearDescription: 'Carga la inversión por canal que el modelo propaga para el próximo año.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagBlank: 'En blanco',
  chooseTagCarryOver: 'Carry-over',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Fechas Flexibles',
  chooseFlexibleTitle: 'Fechas Flexibles',
  chooseFlexibleDescription: 'Elige cualquier período: se completa con la inversión real donde el modelo la tiene y con la propagación de presupuesto después.',
  chooseTagFlexible: 'Flexible',
  flexibleSummaryActual: 'Inversión real',
  flexibleSummaryPropagation: 'Propagación de presupuesto',
  flexibleSummaryEmpty: 'Sin datos, empieza en 0',
  flexibleSummaryTotal: 'Presupuesto precargado',
  flexibleMonths: '{count} mes | {count} meses',
  flexibleWeeks: '{count} semana | {count} semanas',
  flexibleHintActual: 'Hay inversión real disponible hasta {date}.',
  flexibleHintPropagation: 'La propagación de presupuesto cubre de {from} a {to}.',
  channelMismatchTitle: 'Los canales del modelo cambiaron',
  channelMismatchIntro: 'Los canales de medios de este modelo ya no coinciden con los de este plan, probablemente porque el modelo se actualizó después de crear el plan. Si continúas, el plan usará los canales actuales del modelo.',
  channelMismatchRemoved: 'Canales del plan que ya no existen en el modelo (su inversión se descartará):',
  channelMismatchAdded: 'Canales nuevos del modelo que no estaban en el plan (comenzarán en 0):',
  channelMismatchProceedAnyway: 'Continuar de todos modos',
  channelMismatchCancel: 'Cancelar'
}
